import { addDays, differenceInDays } from 'date-fns';
import { midnightTodayInTZ } from './time';

const forecastRangeSegmentDateProperties = ({
  date,
  range,
  timezone,
}: {
  date: Date;
  range: number;
  timezone: string;
}) => {
  const newEndDate = addDays(date, range);
  return {
    forecastStart: differenceInDays(date, midnightTodayInTZ(timezone)),
    forecastEnd: differenceInDays(newEndDate, midnightTodayInTZ(timezone)),
    forecastYear: date.getFullYear(),
  };
};

export default forecastRangeSegmentDateProperties;
